<template>
  <v-card height="100%" style="border-radius: 0px; overflow-y: hidden !important;" class="mx-auto overflow-hidden">
      <v-app-bar height="72" elevation="0" color="white" class="workspace-app-bar">

          <v-spacer></v-spacer>

          <div class="aj-brand-strip" aria-label="Administradores judiciais">
              <img src="@/assets/logo-paoli.png" alt="Paoli Balbino e Barros" class="aj-brand-strip__logo aj-brand-strip__logo--paoli" />
              <span class="aj-brand-strip__divider" aria-hidden="true"></span>
              <img src="@/assets/logo-bej.png" alt="Brizola e Japur" class="aj-brand-strip__logo aj-brand-strip__logo--bej" />
              <span class="aj-brand-strip__divider" aria-hidden="true"></span>
              <img src="@/assets/logo-inocencio-paula.png" alt="Inocêncio de Paula" class="aj-brand-strip__logo aj-brand-strip__logo--inocencio" />
          </div>

          <v-spacer></v-spacer>

          <v-menu min-width="200" offset-y>
              <template v-slot:activator="{ on, attrs }">
                  <button type="button" class="header-user-trigger" v-bind="attrs" v-on="on">
                      <span class="header-user-name">{{ user.name }}</span>
                      <v-avatar size="40">
                          <img :src="'https://ui-avatars.com/api/?name=' + user.name" :alt="`Avatar de ${user.name}`" />
                      </v-avatar>
                      <v-icon size="16" class="header-user-chevron">mdi-chevron-down</v-icon>
                  </button>
              </template>
              <v-list>
                  <div class="logged-user d-none d-sm-flex ml-4 mb-3">
                      <span class="logged-user-name font-weight-bold">{{ user.name }}</span>
                      <span class="logged-user-email">{{ user.email }}</span>
                  </div>
                  <hr class="v-divider" aria-orientation="horizontal" role="separator">
                  <template v-for="(menuOption, index) in profileMenu">
                      <MenuItem :key="index" :item="menuOption" v-if="!menuOption || !menuOption.children">
                      </MenuItem>
                  </template>
              </v-list>
          </v-menu>
      </v-app-bar>
      <!-- <ProgressBar></ProgressBar> -->

      <template>
          <v-card class="mx-auto overflow-hidden" style="border-radius: 0px; overflow-y: hidden !important;">
              <v-navigation-drawer app v-model="drawer" permanent :expand-on-hover="!drawer" :mini-variant.sync="mini"
                  width="276" mini-variant-width="64" floating hide-overlay class="v-navigation-drawer1">

                  <div class="sidebar-header" :class="{ 'sidebar-header--mini': mini }">
                      <div class="sidebar-brand" v-if="!mini">
                          <span class="sidebar-brand__mark">RJ</span>
                          <span class="sidebar-brand__copy">
                              <strong>Administração Judicial</strong>
                              <small>Portal de gestão</small>
                          </span>
                      </div>
                      <v-btn icon small class="sidebar-toggle" id="menuItem" aria-label="Alternar menu"
                          @click.stop="drawer = !drawer">
                          <v-icon size="20">mdi-menu</v-icon>
                      </v-btn>
                  </div>

                  <v-list dense shaped subheader>
                      <div class="sidebar-navigation">
                          <template v-for="(menuGroup, index) in sidebarMenu">

                              <v-subheader v-if="shouldDisplayMenuGroup(menuGroup) && !mini" :key="`group-${index}`"
                                  class="menu-subheader">
                                  {{ menuGroup.name }}
                              </v-subheader>
                              <div v-else-if="shouldDisplayMenuGroup(menuGroup)" :key="`group-${index}`"
                                  class="sidebar-mini-spacer" aria-hidden="true"></div>
                              <template v-for="(menuOption, childIndex) in menuGroup.children">
                                  <MenuGroup v-if="menuOption.children && hasMenuAccess(menuOption)" :item="menuOption" :user="user"
                                      :key="`submenu-${index}-${childIndex}`" />
                                  <MenuItem v-else-if="!menuOption.children && hasMenuAccess(menuOption)" :item="menuOption"
                                      :key="`option-${index}-${childIndex}`" />
                              </template>
                          </template>
                      </div>
                  </v-list>
              </v-navigation-drawer>
          </v-card>
      </template>
      <router-view></router-view>
  </v-card>
</template>

<script>
// import userApi from "@/common/api/user.api";
import { eventHub } from "@/main";

import router from '../router';

import MenuItem from "@/layouts/components/MenuItem";
import MenuGroup from "@/layouts/components/MenuGroup";
//import toolbarMenu from "@/common/data/toolbar-menu.data"
import profileMenu from "@/common/data/profile-menu.data"
import sidebarMenu from "@/common/data/sidebar-menu.data"

export default {
  name: "PrivateLayout",

  components: {
      MenuItem,
      MenuGroup,
  },

  data() {
      return {
          logoUrl: null,
          menuGroups: [],
          drawer: false,
          searchTerm: null,
          user: null,
          displaySettingsMenu: false,
          // toolbarMenu: toolbarMenu,
          sidebarMenu: sidebarMenu,
          profileMenu: profileMenu,
          mini: undefined,
          selected: undefined,
      };
  },

  computed: {
      routeName() {
          return this.$route.name;
      },
  },

  created() {
      this.user = this.$root.user.data || this.$root.user;

      //console.log('user ', this.user)
      //console.log('side bar menu', this.sidebarMenu)
      //console.log('menugroup ', this.user)

      // eventHub.$on("close-menu", () => {
      //     this.closeMenu();
      // });

      eventHub.$on("logout", () => {
          this.logout();
      })

      this.setActionButtons();

  },

  destroyed() {
      eventHub.$off("THEME_UPDATED");
  },

  methods: {
      shouldDisplayMenuGroup(menuGroup) {
          return (menuGroup.children || []).some(child => this.hasMenuAccess(child));
      },

      hasMenuAccess(item) {
          if (item.children) return item.children.some(child => this.hasMenuAccess(child));
          return this.$check(this.user, item.permissions);
      },

      setActionButtons() {
          // Grupo
      },

      // closeMenu() {
      //     this.$refs.menu.save()
      // },

      menuActionClick(event) {
          event.preventDefault()
      },

      async logout() {
          // if (await this.$root.$confirm(true, "user.logout")) {
          //     userApi.clearcurrentUser;
          //     this.$router.push({ name: "Login" });
          // }

          localStorage.clear();
          router.push("/login");
      },
  },
};
</script>

<style scoped lang="scss">
.title {
  color: var(--v-primary-base);
  text-decoration: none;
}

.menu-button-container {
  background-color: var(--v-secondary-base) !important;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 80px;
  text-align: center;
}

.menu-button {
  margin: auto;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

.logged-user {
  text-align: left;
  margin-right: 10px;
  font-size: 13px;
  font-weight: 400;
  flex-direction: column;

  &-name {
      display: block;
  }

  &-email {
      display: block;
  }
}

.menu-subheader {
  color: #9aa3ad;
  font-size: 9px;
  font-style: normal;
  font-family: "Plus Jakarta Sans", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-weight: 500;
  letter-spacing: .12em;
  line-height: 18px;
  min-height: 32px;
  padding: 14px 18px 4px;
  text-transform: uppercase;
}

.menu-title {
  padding-left: 16px;
  color: var(--v-important-base);
  // font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
}

.v-divider {
  display: block;
  flex: 1 1 100%;
  height: 0px;
  max-height: 0px;
  opacity: 20%;
  transition: inherit;
  border-style: solid;
  border-width: thin 0 0 0;
}

.v-divider-sidebar {
  flex: 1 1 100%;
  height: 0px;
  max-height: 0px;
  opacity: 25%;
  transition: inherit;
  border-style: solid;
  border-width: thin 10 10 10;
  color: var(--v-primary_sidebar_titles-base);
  max-width: 25px;
}

.v-navigation-drawer1 {
  background: #fff !important;
  border-right: 1px solid #edf0f2;
  box-shadow: none !important;
  overflow: hidden !important;
  overflow-x: hidden !important;
}

.v-navigation-drawer1,
.v-navigation-drawer1 ::v-deep * {
  font-family: "Plus Jakarta Sans", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
}

.workspace-app-bar {
  border-bottom: 1px solid #edf1f5 !important;
}

.workspace-app-bar ::v-deep .v-toolbar__content {
  height: 72px !important;
  padding: 0 16px;
}

.header-user-trigger {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 9px;
  color: #29313b;
  display: inline-flex;
  gap: 10px;
  margin-right: 8px;
  min-height: 48px;
  padding: 4px 6px 4px 12px;
  transition: background-color .14s ease;
}

.header-user-trigger:hover,
.header-user-trigger:focus-visible {
  background: #f5f6f7;
  outline: none;
}

.header-user-name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-user-chevron {
  color: #8b95a1 !important;
  margin-left: -4px;
}

.aj-brand-strip {
  align-items: center;
  display: flex;
  gap: 15px;
  left: 20px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.aj-brand-strip__logo {
  display: block;
  filter: grayscale(1);
  height: auto;
  object-fit: contain;
  opacity: .64;
}

.aj-brand-strip__logo--paoli {
  max-height: 30px;
  width: 50px;
}

.aj-brand-strip__logo--bej {
  max-height: 28px;
  width: 63px;
}

.aj-brand-strip__logo--inocencio {
  max-height: 27px;
  width: 102px;
}

.aj-brand-strip__divider {
  background: #e2e8f0;
  height: 24px;
  width: 1px;
}

@media (max-width: 1100px) {
  .aj-brand-strip {
    gap: 10px;
  }

  .aj-brand-strip__logo--paoli {
    width: 42px;
  }

  .aj-brand-strip__logo--bej {
    width: 52px;
  }

  .aj-brand-strip__logo--inocencio {
    width: 84px;
  }
}

@media (max-width: 850px) {
  .aj-brand-strip {
    display: none;
  }

  .header-user-name,
  .header-user-chevron {
    display: none;
  }

  .header-user-trigger {
    padding-left: 4px;
  }
}

.sidebar-navigation {
  padding: 4px 8px 24px;
}

.sidebar-mini-spacer {
  height: 10px;
}

.sidebar-header {
  align-items: center;
  border-bottom: 1px solid #edf1f5;
  display: flex;
  height: 72px;
  justify-content: space-between;
  padding: 0 14px 0 16px;
}

.sidebar-header--mini {
  justify-content: center;
  padding: 0;
}

.sidebar-brand {
  align-items: center;
  display: flex;
  min-width: 0;
}

.sidebar-brand__mark {
  align-items: center;
  background: var(--v-primary-base);
  border-radius: 9px;
  color: #fff;
  display: inline-flex;
  flex: 0 0 36px;
  font-size: 12px;
  font-weight: 800;
  height: 36px;
  justify-content: center;
  letter-spacing: -.02em;
}

.sidebar-brand__copy {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  min-width: 0;
}

.sidebar-brand__copy strong {
  color: #172033;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-brand__copy small {
  color: #8491a3;
  font-size: 11px;
  font-weight: 400;
  margin-top: 2px;
}

.sidebar-toggle {
  color: #526173 !important;
  flex: 0 0 auto;
}

.sidebar-toggle:hover {
  background: #f3f4f5;
}

.v-navigation-drawer1 ::v-deep .v-navigation-drawer__content {
  height: 100%;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  scrollbar-width: none;
}

.v-navigation-drawer1 ::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .v-list {
  padding: 0 !important;
  width: 100%;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant .sidebar-navigation {
  padding: 4px 6px 24px;
  width: 100%;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .sidebar-menu-item,
.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .sidebar-menu-group {
  box-sizing: border-box;
  margin-left: 4px !important;
  margin-right: 4px !important;
  width: calc(100% - 8px) !important;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .sidebar-menu-group > .v-list-group__header {
  box-sizing: border-box;
  margin: 0 !important;
  width: 100% !important;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .sidebar-menu-item,
.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .sidebar-menu-group > .v-list-group__header {
  justify-content: center;
  min-height: 42px !important;
  padding: 0 !important;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .v-list-item__icon {
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  min-width: 20px !important;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .v-list-item__content,
.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .v-list-group__header__append-icon {
  display: none !important;
}

.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .sidebar-menu-item.v-list-item--active,
.v-navigation-drawer1.v-navigation-drawer--mini-variant ::v-deep .sidebar-menu-group--active > .v-list-group__header {
  box-shadow: none;
}

.v-navigation-drawer--mini-variant, .v-navigation-drawer {
  overflow: visible !important;
}


</style>
